import { SalaryRange } from '@hh.ru/types-hh-microcore';
import { YearMonthDayString } from 'bloko/blocks/calendar/datesHelper';

import CompetitionLevel from 'src/constants/competitionLevel';
import Population from 'src/constants/population';
import PublicationType from 'src/constants/publicationType';
import RecruitingStage from 'src/constants/recruitingStage';
import WorkExperience from 'src/constants/workExperience';

enum Filter {
    StartDate = 'startDate',
    EndDate = 'endDate',
    Date = 'date',
    Managers = 'employerManagerId',
    Areas = 'areaId',
    Population = 'population',
    ProfRoles = 'profRoleId',
    ShowVacancies = 'showVacancies',
    PublicationTypes = 'publicationType',
    Stage = 'stage',
    VacancyBrandedTemplates = 'templateKey',
    Vacancy = 'vacancyId',
    SalaryRange = 'salaryRange',
    WorkExperience = 'workExperience',
    CompetitionLevel = 'competitionLevel',
    Page = 'page',
    SortBy = 'sortBy',
}

export const MULTI_PARAMS_FILTERS = [
    Filter.Managers,
    Filter.Areas,
    Filter.ProfRoles,
    Filter.ShowVacancies,
    Filter.PublicationTypes,
    Filter.Population,
    Filter.SalaryRange,
    Filter.WorkExperience,
    Filter.CompetitionLevel,
];

export interface FilterType {
    [Filter.StartDate]: YearMonthDayString;
    [Filter.EndDate]: YearMonthDayString;
    [Filter.Date]: YearMonthDayString;
    [Filter.Managers]: string[];
    [Filter.Areas]: string[];
    [Filter.Population]: Population[];
    [Filter.ProfRoles]: string[];
    [Filter.PublicationTypes]: PublicationType[];
    [Filter.Page]: number;
    [Filter.SalaryRange]: SalaryRange[];
    [Filter.WorkExperience]: WorkExperience[];
    [Filter.CompetitionLevel]: CompetitionLevel[];
    [Filter.SortBy]: string;
    [Filter.ShowVacancies]: string[];
    [Filter.Stage]: RecruitingStage;
    [Filter.VacancyBrandedTemplates]: string | null;
    [Filter.Vacancy]: string | null;
}

export default Filter;
